import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'dashboard',
  children: {
    nps: {
      path: 'nps',
    },
    post: {
      path: 'post',
      children: {
        new: {
          path: 'new',
        },
        newEvent: {
          path: 'new-event',
        },
        id: {
          path: ':id',
          children: {
            edit: {
              path: 'edit',
            },
          },
        },
      },
    },
    kudos: {
      path: 'kudos',
      children: {
        new: {
          path: 'new',
        },
        id: {
          path: ':id',
          children: {
            edit: {
              path: 'edit',
            },
          },
        },
      },
    },
    communities: {
      path: 'communities',
      children: {
        id: {
          path: ':id',
        },
      },
    },
    groups: {
      path: 'groups',
      children: {
        new: {
          path: 'new',
        },
        join: {
          path: 'join',
        },
        id: {
          path: ':id',
          children: {
            leave: {
              path: 'leave',
            },
            edit: {
              path: 'edit',
            },
            delete: {
              path: 'delete',
            },
            addMembers: {
              path: 'add_members',
            },
            removeMembers: {
              path: 'remove_members',
            },
          },
        },
      },
    },
    companyLinksEdit: {
      path: 'company_links/edit',
    },
    configuration: {
      path: 'configuration',
    },
  },
} as const satisfies Location
